import { LoginConfiguration } from '@pages/login/models/login-configuration/login-configuration.interface';
import { Credentials } from '@pages/login/models/login-flow/credentials.interface';
import { LoginStep } from '@pages/login/models/login-step.enum';

const actionScope = '[Login]';

export class LoadLoginConfiguration {
  static readonly type = `${actionScope} Load Login Configuration`;

  constructor(public loginConfiguration: LoginConfiguration) {}
}

export class LogIn {
  static readonly type = `${actionScope} Log In`;

  constructor(public credentials: Credentials) {}
}

export class UpdateStep {
  static readonly type = `${actionScope} Update Step`;

  constructor(public loginStep: LoginStep) {}
}

export class CheckMfa {
  static readonly type = `${actionScope} Check Mfa`;

  constructor(public mfaToken: string) {}
}

export class MfaTokenExpiredError {
  static readonly type = `${actionScope} Mfa Token Expired Error`;
}
